import type * as React from "react";

import { cn } from "../lib/cn";

/** working = in progress, flag = needs a look, stopped = halted, brian = Brian did this. */
export type SwipeTone = "working" | "flag" | "stopped" | "brian";

// Shared with Band; not in the barrel.
export const toneWash: Record<SwipeTone, string> = {
  working: "bg-wash-working",
  flag: "bg-wash-flag",
  stopped: "bg-wash-stopped",
  brian: "bg-wash-brian",
};

// Shared with StatusMark so marked and unmarked rows align; not in the barrel.
export const markShape = {
  row: "inline-flex items-center gap-1",
  icon: "inline-flex shrink-0 items-center",
} as const;

export interface SwipeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone: SwipeTone;
  /** aria-hidden; giving one makes the swipe a single-line row that no longer wraps. */
  icon?: React.ReactNode;
  children: React.ReactNode;
  ref?: React.Ref<HTMLSpanElement>;
}

/**
 * A highlighter stroke over a status word. A wash never appears without its
 * word; with only a colour to say, use the matching `ink-*` instead.
 */
export function Swipe({
  tone,
  icon,
  children,
  className,
  ...rest
}: SwipeProps) {
  return (
    <span
      className={cn(
        toneWash[tone],
        "blend-marker rounded-swipe text-ink",
        "px-[0.45em] pt-[0.1em] pb-[0.15em]",
        "[box-decoration-break:clone] [-webkit-box-decoration-break:clone]",
        icon != null && markShape.row,
        className,
      )}
      {...rest}
    >
      {icon != null && (
        <span aria-hidden="true" className={markShape.icon}>
          {icon}
        </span>
      )}
      {children}
    </span>
  );
}
